const allRoles = [
  1, // CASHIER Junior agent
  2, // ADMIN Senior Agent
  3, // Master Agent
  8, // FINANCER_AGENT
  9, // CAPITALIST_AGENT
  10, // ADMINISTRATOR
];

const prevDefaultCommission = {
  10: 9,
  9: 8,
  8: 3,
  3: 2,
  2: 1,
  1: 0,
};

const domain = 'https://ganamos.staging.betronic.io';

export { allRoles, prevDefaultCommission, domain };
